import React from 'react';
import { Field } from "redux-form";
import { TextField } from 'redux-form-material-ui';
import { Table, TableBody, TableRow, TableRowColumn, TableHeader, TableHeaderColumn } from "material-ui/Table";
import { DivSmallItemBox,DivSmallBox  } from "../styled";
import { renderNumberField, renderToggle, renderChipVariantName} from "../ProductFormField";

import { styles } from "../styles";
// <TableHeaderColumn tooltip={translate('resources.products.fieldList.variantField.sku')}>{translate('resources.products.fieldList.variantField.sku')}</TableHeaderColumn>
export const renderVariantList = ({ fields, translate }) => (
  <Table selectable={false}>
    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
      <TableRow>
        <TableHeaderColumn>{translate('resources.products.fieldList.variantField.name')} and {translate('resources.products.fieldList.variantField.sku')}</TableHeaderColumn>
        <TableHeaderColumn tooltip={translate('resources.products.fieldList.variantField.price')} style={{width:120}}>{translate('resources.products.fieldList.variantField.price')}</TableHeaderColumn>
        <TableHeaderColumn
          tooltip={translate('resources.products.fieldList.variantField.quantity')}
          style={styles.containerSmallFields}
        >
          {translate('resources.products.fieldList.variantField.quantity')}
        </TableHeaderColumn>
        <TableHeaderColumn tooltip="Active" style={styles.containerActive}>
        {translate('resources.products.fieldList.variantField.active')}
        </TableHeaderColumn>
      </TableRow>
    </TableHeader>
    <TableBody displayRowCheckbox={false} showRowHover={true}>
      {fields.map(renderVariantFields)}
    </TableBody>
  </Table>
);

export const renderVariantFields = (items, index, fields) => {
  return (
    <TableRow key={index}>
      <TableRowColumn>
        <DivSmallBox>
          <Field
            label=""
            name={`${items}.name`}
            component={renderChipVariantName}
          />
          <Field
            label=""
            fullWidth={true}
            name={`${items}.sku`}
            component={TextField}
            floatingLabelText="SKU"
          />
        </DivSmallBox>
      </TableRowColumn>
      <TableRowColumn style={{width:120}}>
        <Field
          label=""
          style={{width:110}}
          name={`${items}.price`}
          component={renderNumberField}
          parse={v => v * 1}
          placeholder="qty"
        />
      </TableRowColumn>
      <TableRowColumn style={styles.containerSmallFields}>
        <Field
          label=""
          name={`${items}.qty`}
          style={styles.containerSmallFields}
          component={renderNumberField}
          parse={v => v * 1}
          placeholder="qty"
        />
      </TableRowColumn>
      <TableRowColumn style={styles.containerActive}>
        <Field
          name={`${items}.active`}
          label="Active"
          parse={v => (v === "" ? false : v)}
          component={renderToggle}
        />
      </TableRowColumn>
    </TableRow>
)};

export const renderVariantListSmall = ({ fields, translate }) => (
  <Table selectable={false}>
    <TableBody displayRowCheckbox={false} showRowHover={true}>
      {fields.map((items, index) => renderVariantFieldsSmall(items, index, translate))}
    </TableBody>
  </Table>
);
export const renderVariantFieldsSmall = (items, index, translate) =>  (
  <TableRow key={index}>
    <TableRowColumn>
      <DivSmallBox>
        <DivSmallItemBox>
          <Field
            name={`${items}.name`}
            label={translate('resources.products.fieldList.variantField.name')}
            component={renderChipVariantName}
            placeholder="name"
          />
        </DivSmallItemBox>
        <DivSmallItemBox>
          <Field
            name={`${items}.sku`}
            label={translate('resources.products.fieldList.variantField.sku')}
            component={TextField}
            placeholder="sku"
          />
        </DivSmallItemBox>
        <DivSmallItemBox>
          <Field
            name={`${items}.price`}
            label={translate('resources.products.fieldList.variantField.price')}
            component={renderNumberField}
            parse={v => v * 1}
            placeholder="qty"
          />
        </DivSmallItemBox>
        <DivSmallItemBox>
          <Field
            name={`${items}.qty`}
            label={translate('resources.products.fieldList.variantField.quantity')}
            component={renderNumberField}
            parse={v => v * 1}
            placeholder="qty"
          />
        </DivSmallItemBox>
        <DivSmallItemBox>
          <Field
            name={`${items}.active`}
            label={translate('resources.products.fieldList.variantField.active')}
            parse={v => (v === "" ? false : v)}
            component={renderToggle}
          />
        </DivSmallItemBox>
      </DivSmallBox>
    </TableRowColumn>
  </TableRow>
);


// WEBPACK FOOTER //
// ./src/products/edit/VariantField.js